
<template>
  <v-btn v-on="$listeners" v-bind="$attrs" :disabled="disabled" :to="to" :color="btn.color" :text="btn.text" :small="small" :block="block">
    <v-icon size="19" left v-if="!close">{{alt_icon? alt_icon : btn.icon}}</v-icon>
    {{ alt_text? alt_text : btn.label }}
  </v-btn>
</template>

<script>
export default {
  name: 'defaultBtn',
  props:{
    save:{
      type:Boolean,
      default: false,
    },
    cancel:{
      type:Boolean,
      default: false,
    },
    edit:{
      type:Boolean,
      default: false,
    },
    close:{
      type:Boolean,
      default: false,
    },
    update:{
      type:Boolean,
      default: false,
    },
    disabled:{
      type:Boolean,
      default: false,
    },
    to:{
      default: null,
    },
    small:{
      type:Boolean,
      default: true
    },
    block:{
      type:Boolean,
      default: false,
    },
    alt_text: {
      type: String,
      default: null
    },
    alt_icon: {
      type: String,
      default: null
    }
  },
  computed: {
    btn(){
      if(this.save){
        return {label: "SALVAR", icon: "mdi-content-save", text: false, color:"success"}
      }else if(this.cancel){
        return {label: "CANCELAR", icon: "mdi-close", text: true, color:"error"}
      }else if(this.edit){
        return {label: "EDITAR", icon: "mdi-pencil", text: false, color:"primary"}
      }else if(this.close){
        return {label: "FECHAR", icon: "", text: false, color:"error"}
      }else if(this.update){
        return {label: "ATUALIZAR", icon: "mdi-content-save", text: false, color:"success"}
      }else{
        return {label: "error", icon: "mdi-alert-circle-outline", text: false, color:"error"}
      }
    }
  },
}
</script>

